import { useState } from "react";
import { Carousel } from "@mantine/carousel";
import { Box, Image, Stack } from "@mantine/core";

import { WALLPAPERS } from "../wallpapers";

import classes from "./WallpaperCarousel.module.scss";

/** 每張圖寬（= slide 軌道寬）；兩側自然露出 peek。 */
const SLIDE_SIZE = "55vw";
/** 圖與圖之間距離（設計指定 7.1vw）。 */
const SLIDE_GAP = "7.1vw";

interface WallpaperCarouselProps {
	/** 初始置中的 slide index（例如從下一頁返回時記住的位置） */
	initialIndex?: number;
	/** 中間（選中）那張切換時回傳其 index */
	onSelect?: (index: number) => void;
}

export default function WallpaperCarousel({
	initialIndex = 0,
	onSelect,
}: WallpaperCarouselProps) {
	const [selected, setSelected] = useState(initialIndex);
	const count = WALLPAPERS.length;

	return (
		<Stack gap={0} w="100%" align="center">
			<Box className={classes.wrap}>
				<Carousel
					w="100%"
					slideSize={SLIDE_SIZE}
					slideGap={SLIDE_GAP}
					emblaOptions={{
						loop: true,
						align: "center",
						containScroll: false,
						startIndex: initialIndex,
					}}
					withControls={false}
					withIndicators={false}
					onSlideChange={(index) => {
						setSelected(index);
						onSelect?.(index);
					}}
					classNames={{
						root: classes.root,
						viewport: classes.viewport,
						slide: classes.slide,
					}}
				>
					{WALLPAPERS.map((item, index) => (
						<Carousel.Slide
							key={item.id}
							className={index === selected ? classes.slideActive : undefined}
						>
							<Box
								className={
									index === selected
										? `${classes.item} ${classes.active}`
										: classes.item
								}
							>
								<Image
									src={item.src}
									alt={`wallpaper-${item.id}`}
									className={classes.image}
									fit="cover"
									h="100%"
									w="100%"
									draggable={false}
								/>
							</Box>
						</Carousel.Slide>
					))}
				</Carousel>
			</Box>

			{/* 底部進度指示：thumb 寬 = 1/張數，依 selected 位置移動 */}
			<Box className={classes.progress}>
				<Box
					className={classes.progressThumb}
					style={{
						width: `${100 / count}%`,
						left: `${(selected / count) * 100}%`,
					}}
				/>
			</Box>
		</Stack>
	);
}
